import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { NUBE_AWS, URL_ARCHIVO_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES,URL_SERVICIOS_LOCALES_IMPRESORA } from '../../config/url.servicio'
import * as XLSX from 'xlsx';
import { map } from 'rxjs/operators';

@Injectable()
export class InformesProvider {
  urlPrintService:string
  token:string
  constructor(public http: Http,public storage:Storage) {

    this.storage.get('token').then((valorToken) =>{
      this.token = valorToken
    }
    )

    this.storage.get('urlPrint').then((val) => {
      this.urlPrintService = val
  });
  }

buscarinformeVarios(valoresInforme:any,nombreInforme,companiasid:any) {
  let url = URL_SERVICIOS_LOCALES
  let headers = new Headers({
      'Content-Type': 'application/json',
  })
  let options = new RequestOptions({
    headers: headers
  })
    this.http.get(`${url}/query?name=${nombreInforme}${valoresInforme}`, options)
    .subscribe((datos)=>{
        let res = JSON.parse(datos['_body'])
        let stringRes = JSON.stringify(res)
        let nombreInformeCompania = `${nombreInforme}-${companiasid}`
        this.storage.set(`${nombreInformeCompania}`,stringRes)

        this.buscarinformeLocal(res,`${nombreInformeCompania}`)
    })
}

buscarinformeVariosAWS(nombre:any,companiaId:any,fechadesde:any,fechahasta:any) {
    let url_servicio = URL_SERVICIOS_AWS;
    let data = {
      name: nombre,
      parameters : {companiasId:companiaId, fechaDesde:fechadesde, fechaHasta:fechahasta}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    this.http.post(`${url_servicio}/procedure`, data, options)
    .subscribe((datos)=>{
      let res = JSON.parse(datos['_body']).data[0]
      let stringRes = JSON.stringify(res)
      let nombreInformeCompania = `${nombre}-${companiaId}`
      this.storage.set(`${nombreInformeCompania}`,stringRes)

      this.buscarinformeLocal(res,`${nombreInformeCompania}`)
  })
}

buscarinformeCuentasPorCobrarAWS(nombre:any,companiaId:any,clienteId:any,TodasConSaldo:any,fechadesde:any,fechahasta:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: nombre,
    parameters : {companiasId:companiaId,clientesId:clienteId,TodasConSaldo:TodasConSaldo, fechaDesde:fechadesde, fechaHasta:fechahasta}
  }

  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  this.http.post(`${url_servicio}/procedure`, data, options)
  .subscribe((datos)=>{
    let res = JSON.parse(datos['_body']).data[0]
    let stringRes = JSON.stringify(res)
    let nombreInformeCompania = `${nombre}-${companiaId}`
    this.storage.set(`${nombreInformeCompania}`,stringRes)

    this.buscarinformeLocal(res,`${nombreInformeCompania}`)
})
}

buscarResumenCuentasPorCobrarConEstado(entidadesId:any,clientesId:any,fechaDesde:any,fechaHasta:any,estado:any,companiasId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: 'informeResumenCuentasPorCobrarConEstado',
    parameters : {entidadesId:entidadesId,clientesId:clientesId,fechaDesde:'1900-01-01',fechaHasta:'1900-01-01',estado:estado,companiasId:companiasId}
  }

  let headers = new Headers({ 'Content-Type': 'application/json' })
  let options = new RequestOptions({ headers: headers })
  return this.http.post(`${url_servicio}/procedure`, data, options)
}

buscarSeguimientosDetalladosCuentasPorCobrarPorEntidad(companiasId: any, entidadesId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let pageSize = 5000; // Número de registros a obtener por página

  // Crea una función recursiva para obtener todas las páginas
  const getPaginatedData = (page: number, allData: any[]) => {
    return new Promise((resolve, reject) => {
      let data = {
        name: 'buscarSeguimientosDetalladosCuentasPorCobrarPorEntidad',
        parameters: {
          companiasId: companiasId,
          entidadesId: entidadesId,
          registrosPorPagina: pageSize,
          paginaMuestro: page
        }
      };

      let headers = new Headers({ 'Content-Type': 'application/json' });
      let options = new RequestOptions({ headers: headers });

      this.http.post(`${url_servicio}/procedure`, data, options).subscribe(
        (response: any) => {
          const responseData = response.json();
          const currentData = responseData.data || [];

          const esLaUltimaPagina = currentData[0] !== undefined && currentData[0][0] !== undefined && currentData[0][0].esLaUltimaPagina !== undefined
            ? currentData[0][0].esLaUltimaPagina : 'S';

          allData = allData.concat(currentData);

          // Si aún hay más páginas, obtén los datos de la siguiente página
          if (esLaUltimaPagina === 'N') {
            const nextPage = page + 1;
            getPaginatedData(nextPage, allData).then(resolve).catch(reject);
          } else {
            // Si no, devuelve todos los registros juntos
            resolve(allData);
          }
        },
        (error: any) => {
          reject(error);
        }
      );
    });
  };

  // Llama a la función recursiva con la primera página
  return getPaginatedData(1, []);
}

// buscarSeguimientosDetalladosCuentasPorCobrarPorEntidadAgrupado(companiasId: any,entidadesId:any, fecha: any,paginaActual:any,cantidadDeRegistros:any) {
//   let url_servicio = URL_SERVICIOS_AWS;

//   let data = {
//     name: 'informeCuentasPorCobrarTotalizado',
//     parameters : {companiasId:companiasId,entidadesId:entidadesId, fecha: fecha,paginaActual:paginaActual,cantidadDeRegistros:cantidadDeRegistros}
//   }

//   let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
//   let options = new RequestOptions({ headers: headers }) // Create a request option
//   return this.http.post(`${url_servicio}/procedure`, data, options)
// }



buscarSeguimientosDetalladosCuentasPorCobrar(companiasId:any,clientesId:any,cuentasPorCobrarId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: 'buscarSeguimientosDetalladosCuentasPorCobrar',
    parameters : {companiasId:companiasId,clientesId:clientesId,cuentasPorCobrarId:cuentasPorCobrarId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options)
}


informeResumenCuentasPorCobrarPlanDePago(numeroFactura:any,companiasId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: 'informeResumenCuentasPorCobrarPlanDePago',
    parameters : {numeroFactura:numeroFactura,companiasId:companiasId}
  }

  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  return this.http.post(`${url_servicio}/procedure`, data, options)
}



buscarinformeVariosIngresoDeMercanciaAWS(nombre:any,companiasId:any,fechaDesde:any,fechaHasta:any, proveedoresId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: nombre,
    parameters : {companiasId:companiasId, fechaDesde:fechaDesde, fechaHasta:fechaHasta,proveedoresId:proveedoresId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  this.http.post(`${url_servicio}/procedure`, data, options)
  .subscribe((datos)=>{
    let res = JSON.parse(datos['_body']).data[0]
    let stringRes = JSON.stringify(res)
    let nombreInformeCompania = `${nombre}-${companiasId}`
    this.storage.set(`${nombreInformeCompania}`,stringRes)

    this.buscarinformeLocal(res,`${nombreInformeCompania}`)
})
}


buscarinformeVariosProductosAWS(nombre:any,companiaId:any,productosId:any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: nombre,
    parameters : {companiasId:companiaId, productosId:productosId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  this.http.post(`${url_servicio}/procedure`, data, options)
  .subscribe((datos)=>{
    let res = JSON.parse(datos['_body']).data[0]
    let stringRes = JSON.stringify(res)
    let nombreInformeCompania = `${nombre}-${companiaId}`
    this.storage.set(`${nombreInformeCompania}`,stringRes)

    this.buscarinformeLocal(res,`${nombreInformeCompania}`)
})
}


buscarinformeVariosCuadreDiarioAWS(nombre:any,companiaId:any,fechadesde:any,fechahasta:any, usuariosId: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: nombre,
    parameters : {companiasId:companiaId, fechaDesde:fechadesde, fechaHasta:fechahasta, usuariosId: usuariosId}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  this.http.post(`${url_servicio}/procedure`, data, options)
  .subscribe((datos)=>{
    let res = JSON.parse(datos['_body']).data[0]
    let stringRes = JSON.stringify(res)
    let nombreInformeCompania = `${nombre}-${companiaId}`
    this.storage.set(`${nombreInformeCompania}`,stringRes)

    this.buscarinformeLocal(res,`${nombreInformeCompania}`)
})
}

buscarinformeVariosVentasDevueltasAWS(nombre:any,companiaId:any,fechadesde:any,fechahasta:any,totales:any, consecutivo: any) {
  let url_servicio = URL_SERVICIOS_AWS;
  let data = {
    name: nombre,
    parameters : {companiasId:companiaId, fechaDesde:fechadesde, fechaHasta:fechahasta, totales:totales, consecutivo:consecutivo}
  }
  let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
  let options = new RequestOptions({ headers: headers }) // Create a request option
  this.http.post(`${url_servicio}/procedure`, data, options)
  .subscribe((datos)=>{
    let res = JSON.parse(datos['_body']).data[0]
    let stringRes = JSON.stringify(res)
    let nombreInformeCompania = `${nombre}-${companiaId}`
    this.storage.set(`${nombreInformeCompania}`,stringRes)

    this.buscarinformeLocal(res,`${nombreInformeCompania}`)
})
}

buscarinformeLocal(data:any,nombreInformeCompania:any) {
  if(NUBE_AWS) {
    let url_servicio = URL_SERVICIOS_AWS;
    let values = {
      name: "informes",
      parameters : { "data": JSON.stringify(data),
      "nombre":nombreInformeCompania}
    }
    let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    let options = new RequestOptions({ headers: headers }) // Create a request option
    this.http.post(`${url_servicio}/procedure`, values, options)
    .subscribe((data)=>{

    },(error)=>{

    })
    let variable = `${nombreInformeCompania}`
    let dataReal = JSON.stringify(data)
    this.storage.set(variable,dataReal)
  } else {
  let url = URL_SERVICIOS_LOCALES
  let headers = new Headers({
      'Content-Type': 'application/json',
  })
  let options = new RequestOptions({
    headers: headers
  })
  const datos = {
      "data": JSON.stringify(data),
      "nombre":nombreInformeCompania
      }

  this.http.post(`${url}/informes`,datos,options)
  .subscribe((data)=>{

  },(error)=>{

  })
  let variable = `${nombreInformeCompania}`
  let dataReal = JSON.stringify(data)
  this.storage.set(variable,dataReal)
 }
}

 imprimirRecibo (text) {
  const url = this.urlPrintService || URL_SERVICIOS_LOCALES_IMPRESORA

  const headers = new Headers({
      'Content-Type': 'application/json'
  })

  const options = new RequestOptions({
      headers: headers
  })

  return this.http
      .post(url, {text: text, texto:text, cut: true, cash: true}, options)
}

  buscarListadoRecibosCajaReImprime (companiasId:any, fechaDesde:Date, fechahasta:Date){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "listadoRecibosCajaReImprime",
        parameters : { "companiasId":companiasId,
        "fechaDesde":fechaDesde,
        "fechaHasta":fechahasta}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES

    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId":companiasId,
        "fechaDesde":fechaDesde,
        "fechaHasta":fechahasta
        }

    return this.http
        .post(`${url}/proceso/listadoRecibosCajaReImprime`, datos, options)
    }
  }


  buscarListadoDevolverVenta (companiasId:any, fechaDesde:Date, fechahasta:Date){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "buscarVentasADevolver",
        parameters : { "companiasId":companiasId,
        "fechaDesde":fechaDesde,
        "fechaHasta":fechahasta}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES

    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId":companiasId,
        "fechaDesde":fechaDesde,
        "fechaHasta":fechahasta
        }

    return this.http
        .post(`${url}/proceso/listadoRecibosCajaReImprime`, datos, options)
    }
  }

  buscarVentasDiariasHistorico(elRecibo:any,val:any,fecha:any){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "imprimirReciboCajaHistorico",
        parameters : { "elRecibo":elRecibo,
        "companiasId":val,
        "fechaRecibo":fecha}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/query?name=imprimirReciboCajaHistorico&elRecibo=${elRecibo}&companiasId=${val}&fechaRecibo=${fecha}`)
      .map((data) => data.json())
    }
  }

  guardarArchivo(archivo: any) {
      var data = new FormData();
      data.append('file', archivo)
      let url_servicio_aws_archivo = URL_ARCHIVO_AWS;
      return this.http.post(`${url_servicio_aws_archivo}/dev/image-upload`, data)
      .map((data) =>  data.json())
  }

  async exportToExcel(data, filename) {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, filename);
    XLSX.writeFile(wb, filename + '.xlsx');
  }

  cantidadVentasEmitidas (companiasId:any, fechaDesde:Date, fechahasta:Date){
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "cantidadVentasEmitidas",
        parameters : { "companiasId":companiasId,
        "fechaDesde":fechaDesde,
        "fechaHasta":fechahasta}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
    } else {
    let url = URL_SERVICIOS_LOCALES

    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })

    const datos = {
        "companiasId":companiasId,
        "fechaDesde":fechaDesde,
        "fechaHasta":fechahasta
        }

    return this.http
        .post(`${url}/proceso/listadoRecibosCajaReImprime`, datos, options)
    }
  }

  gestionarClienteDescripcion(companiasId:any, clientesId:Date, descripcion:Date){
   let url_servicio = URL_SERVICIOS_AWS;
      let data = {
        name: "gestionarClientesDescripcion",
        parameters : { "companiasId":companiasId,
        "clientesId":clientesId,
        "descripcion":descripcion}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, data, options);
  }

  async buscarSeguimientosDetalladosCuentasPorCobrarPorEntidadAgrupado(companiasId: any,entidadesId:any, fecha: any,paginaActual:any,cantidadDeRegistros:any) {
    let response;
    try {
      let url_servicio = URL_SERVICIOS_AWS;

      let data = {
        name: 'informeCuentasPorCobrarTotalizado',
        parameters : {companiasId:companiasId,entidadesId:entidadesId, fecha: fecha,paginaActual:paginaActual,cantidadDeRegistros:cantidadDeRegistros}
      }

    // let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
    // let options = new RequestOptions({ headers: headers }) // Create a request option
    // return this.http.post(`${url_servicio}/procedure`, data, options)
      const headers = new Headers({ 'Content-Type': 'application/json' }); // Establecer tipo de contenido como JSON
      const options = new RequestOptions({ headers: headers }); // Crear opciones de la solicitud

      response = await this.http.post(`${url_servicio}/procedure`, data, options).toPromise();
      return response;
    } catch (error) {
      // Manejo de errores
      console.error('Error en buscarCuentaPorCobrar:', error);
      throw error;
    }
  }


}



// WEBPACK FOOTER //
// ./src/providers/informes/informes.ts